// extracted by mini-css-extract-plugin
module.exports = {"checkbox_container":"styles_checkbox_container__3FQ_v","checkbox_component":"styles_checkbox_component__1szds","checked":"styles_checked__1_F19","label":"styles_label__3legl"};